import { Component, OnDestroy, OnInit, NgZone } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoginDialogComponent } from 'cad/login/dialog/login-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'login-content',
  template: '',
})
export class LoginContentComponent implements OnDestroy, OnInit {

  private dialogRef: MatDialogRef<LoginDialogComponent>;

  private subscription: Subscription;

  constructor(
    private ngZone: NgZone,
    private dialog: MatDialog
  ) {}

  public ngOnInit(): void {
    setTimeout(() => {
      this.openDialog();
    }); // delay by one cycle to prevent ExpressionChangedAfterItHasBeenCheckedError error
  }

  public ngOnDestroy(): void {
    if (this.subscription) { this.subscription.unsubscribe(); }
    if (this.dialogRef) { this.dialogRef.close(); }
  }

  private openDialog(): void {
    this.ngZone.run(() => {
      this.dialogRef = this.dialog.open(LoginDialogComponent, { disableClose: true });
    });
  }
}
